// extracted by mini-css-extract-plugin
export default {"container":"support_container__L60eC","contents":"support_contents__ZQJQr","title":"support_title__H-ip+"};